import React from 'react';
import PropTypes from 'prop-types';
import {fetchStatements, fetchStatement} from '../../actions/statementsActions';
import {connect} from 'react-redux';
import {
  trackPageView,
  trackUserClick,
  trackUserAttribute
} from '@forwardfinancing/analytics-frontend-library/index';
import utils from '../../lib/utils';
import {
  SimpleDropdown, SummaryRow, SummaryCard, Paginator, SimpleTable, SimpleTableRow
} from '@forwardfinancing/component-library';

export class StatementsPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: null
    };
  }

  componentDidMount() {
    trackPageView({page: 'Statements'});
    if (!this.props.statements){
      this.props.fetchStatements();
    }
  }

  componentDidUpdate() {
    const { currentStatement, statements } = this.props;
    if (statements && !currentStatement && !this.state.currentPage){
      this.fetchStatement(statements[0].record_id);
    }
  }

  fetchStatement(id, page = 1) {
    this.setState({currentPage: page});
    this.props.fetchStatement(id, page);
  }

  renderDropdown(){
    const { statements } = this.props;
    const options = statements.map((statement) => {
      return {
        label: utils.formatDateToString(statement.date_of_advance),
        value: statement.record_id
      }
    })
    let onChange = (e) => {this.fetchStatement(e.target.value)};
    return (
      <SimpleDropdown
        options={options}
        onChange={onChange}
        desiredClassName="statements-page__dropdown"
      />
    );
  }

  renderAdvanceTitle() {
    const { statements } = this.props;
    if (statements && statements.length > 0){
      if (statements.length > 1){
        return this.renderDropdown();
      }else{
        return (
          <span className="statements-page__title title">
            {utils.formatDateToString(statements[0].date_of_advance)}
          </span>

        );
      }
    }
    return null;
  }

  renderExportButton() {
    const { currentStatement } = this.props;
    return (
      <div className="buttons">
        <button
          onClick={() => this.exportPDF(currentStatement.record_id)}
          className="button is-primary export-pdf-button"
        > Export PDF
        </button>
      </div>
    );
  }

  exportPDF(id){
    trackUserClick({attribute: 'export'});
    utils.exportPDF(id);
    trackUserAttribute({attribute: 'export_statement'});
  }

  renderOverage(overage, formatter) {
    if(overage > 0) {
      return(
        <SummaryCard
          title="Due to Merchant"
          body={formatter.format(overage)}
        />
      );
    }
  }

  renderSummary() {
    const { currentStatement } = this.props;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return (
      <div className="statements-page__summary">
        <SummaryRow>
          <SummaryCard
            title="Purchased Amount"
            body={formatter.format(currentStatement.amount)}
          />
          <SummaryCard
            title="Amount Sold"
            body={formatter.format(currentStatement.gross_payback)}
          />
          <SummaryCard
            title="Total Paid"
            body={formatter.format(currentStatement.total_payment)}
          />
          <SummaryCard
            title="Outstanding Balance"
            body={formatter.format(currentStatement.balance)}
          />
          { this.renderOverage(currentStatement.overage, formatter) }
        </SummaryRow>
      </div>
    );
  }

  renderFees() {
    const { currentStatement } = this.props;

    return (
      <div className="statements-page__fees">
        <div className="statements-page__fees-title">Adjustments</div>
        <div className="statements-page__table-container">
          <SimpleTable>
            {
              currentStatement.fees.map((fee, idx) => {
                return (
                  <SimpleTableRow
                    leftHeader={fee.description}
                    leftLabel={fee.date}
                    rightLabel={fee.amount}
                    key={idx}
                  />
                );
              })
            }
          </SimpleTable>
        </div>
      </div>
    );
  }

  renderPayments() {
    const { currentStatement } = this.props;

    return (
      <div className="statements-page__payments">
        <div className="statements-page__payments-title">Payment History</div>
        <div className="statements-page__table-container">
          <SimpleTable>
            {
              currentStatement.payments.map((payment, idx) => {
                return (
                  <SimpleTableRow
                    leftLabel={payment.date}
                    rightLabel={payment.amount}
                    key={idx}
                  />
                );
              })
            }
          </SimpleTable>
          <div className="statements-page__table-paginator">
            <Paginator
              currentPage={this.state.currentPage}
              pageCount={currentStatement.payments_pages || 1}
              onClick={(page) => this.fetchStatement(currentStatement.record_id, page)}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { currentStatement } = this.props;
    return (
      <div className="statements-page page full-width-at-mobile">
        <div className="statements-page__title-container">
          <div className="header">
            <h2>Statements</h2>
          </div>
          <span className="statements-page__title title">Funding Opportunity: </span>
          {this.renderAdvanceTitle()}
        </div>
        {currentStatement && this.renderExportButton()}
        {currentStatement && this.renderSummary()}
        {currentStatement && this.renderFees()}
        {currentStatement && this.renderPayments()}
      </div>
    );
  }
}

StatementsPage.propTypes = {
  statements: PropTypes.array,
  currentStatement: PropTypes.object,
  fetchStatements: PropTypes.func,
  fetchStatement: PropTypes.func
};

export default connect(
  (state) => {
    return {
      statements: state.statements.data,
      currentStatement: state.statements.current,
    };
  },
  {
    fetchStatements,
    fetchStatement
  }
)(StatementsPage);
